import angular from 'angular';
import { MeurhOrganogramaIndexController } from './index/organograma.controller';
import { MeurhOrganogramaService } from './organograma.service';
import { MeurhOrganogramaRouting } from './organograma.routing';

export const MeurhOrganogramaModule = angular.module('MeurhOrganogramaModule', ['ui.router.state', ])
    .controller('MeurhOrganogramaIndexController', MeurhOrganogramaIndexController)
    .service('MeurhOrganogramaService', MeurhOrganogramaService)
    .config(MeurhOrganogramaRouting)
    .name;
